import Button from '@components/Button'
import { isExternalUrl } from 'shared/utils'
import { HOURLY_RESERVATION } from '../../constants'
import StartFromPrice from 'shared/components/StartFromPrice'
import featureToggles from 'shared/featureToggles'
import BuyButton from './BuyButton'
import styles from './styles.module.scss'

const BuyButtonCTA = ({
    opngo,
    externalSeasonTicketUrl,
    buyLabel,
    bookingUrl,
    canBuy,
    searchMode,
    reservationsEnabled,
    monthlyParkingUrl,
    redirectToMonthlyParkingFlow,
    rate,
}) => {
    const isReservation = searchMode === HOURLY_RESERVATION

    return opngo || !!externalSeasonTicketUrl ? (
        <BuyButton
            opngo={opngo}
            externalSeasonTicketUrl={externalSeasonTicketUrl}
            buyLabel={buyLabel}
            reservationsEnabled={reservationsEnabled}
        />
    ) : canBuy ? (
        <Button
            href={redirectToMonthlyParkingFlow ? monthlyParkingUrl : bookingUrl}
            block
            external={!redirectToMonthlyParkingFlow && isExternalUrl(bookingUrl)}>
            <T>{buyLabel}</T>
        </Button>
    ) : (
        <>
            <div className={styles.unbookable}>
                {isReservation ? (
                    <T>map.results.list.book.na.reservation</T>
                ) : (
                    <T>map.results.list.book.na.subscription</T>
                )}
            </div>
            {rate && featureToggles.displayNonBookableLocationsPrice && (
                <StartFromPrice
                    rate={rate}
                    linkUrl={bookingUrl}
                    addSpacing
                    opngo={opngo}
                    canBuy={canBuy}
                    className={styles.priceInfo}
                />
            )}
        </>
    )
}

export default BuyButtonCTA
